import React from 'react'
import './electrical.css'
import Header from "../../../component/header";
import SideNav from '../../../component/sideNav'
import ElectricalDetail from './electricalDetail'


export default function Electrical() {
  return (
    <div className='electricalContainer'>
        <Header></Header>
        <SideNav active="Dashboard" />
        <div className='electricalContent'>
            <ElectricalDetail></ElectricalDetail>
        </div>
    </div>
  )
}
